import '../filter_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.PostLabelsFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'label'
  facetName: 'label'
  alias: 'Group'
  addMissing: true
  selectAll: true

  getAppliedValues: ->
    @searchQuery.get('post_labels')

  addFilter: (value) =>
    @searchQuery.addPostLabel(value)

  removeFilter: (value) =>
    @searchQuery.removePostLabel(value)

  hasOption: (code) =>
    @searchQuery.get('post_labels').indexOf(code) != -1
